import React from 'react';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';
import { SvgProps } from './icon.types';

function CircleChevronUpIcon({
  fill = PlcColor.GREY_CLOUD_MEDIUM,
  fillColor = '#2D3049',
  className,
  ...props
}: SvgProps) {
  const rootClassName = classnames('pointer-events-none', className);
  return (
    <svg className={rootClassName} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0z" fill={fill} fillRule="evenodd" />
      <path
        d="M377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0l87 87z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { CircleChevronUpIcon };
